import UploadImages from '@/components/messages/UploadImages.svelte'
import { mount } from 'svelte'

window.mountImagesApp = function() {
  const target = document.getElementById('message-upload-images-app')
  if (target) {
    mount(
      UploadImages,
      {
        target,
        props: {
          message: target.dataset.message
        }
      }
    )
  }
}
